import { useState } from 'react';

import useTranslations from '@/i18n/useTranslations';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

import './ArtlistConfirmationDialog.css';

export default function ArtlistConfirmationDialog({ 
  open, 
  close, 
  onConfirmSaveAndExit,
  onConfirmCancel,
  canSave, 
  artlist, 
}) {
  const t = useTranslations('common.profile.pages.artlist');
  const [saving, setSaving] = useState(false);

  const hasChanges = artlist && Object.keys(artlist).length > 0;

  const handleSaveAndExit = async () => {
    if (!hasChanges) {
      close();
      return;
    }
    setSaving(true);
    await onConfirmSaveAndExit();
  };

  return (
    <GenericPopup 
      className="artlist-confirmation-dialog remove-scrollbar" 
      open={open} 
      opacity
    >
      <div className="artlist-confirmation-dialog__header">
        <h3 className="artlist-confirmation-dialog__header-text">
          {t('edit_confirmation.title')}
        </h3>
        <XIcon 
          className="artlist-confirmation-dialog__close" 
          onClick={close} 
        />
      </div>

      <div className="artlist-confirmation-dialog__body">
        <Text className="artlist-confirmation-dialog__body-text" paragraph>
          {t('edit_confirmation.description')}
        </Text>
      </div>

      <div className="artlist-confirmation-dialog__action-buttons element-non-selectable">
        <ContinueButton 
          className="artlist-confirmation-dialog__button cancel continue-button_two"
          onClick={onConfirmCancel}
        >
          {t('edit_confirmation.actions.exit')}
        </ContinueButton>

        <ContinueButton 
          loading={saving}
          className="artlist-confirmation-dialog__button confirm continue-button_two"
          onClick={handleSaveAndExit}
          turnOff={!canSave}
        >
          {t('edit_confirmation.actions.save_and_exit')}
        </ContinueButton>
      </div>
    </GenericPopup>
  );
}
